/* eslint-env browser */
/* eslint-disable no-console */
import React from 'react';
import moment from 'moment';
import {Link} from 'react-router-dom';
import PdfCell from '../components/invoice/PdfCell';
import {isCredit} from "../components/invoice/InvoiceList";

// import Invoice from '../Models/Invoice';

export function paidFormatter(cell, row) {
  if (isCredit(row)) {
    return '';
  }
  if (row.currency_key === 'USD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.paid_amount)} </small></span>);
  }
  if (row.currency_key === 'CAD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.paid_amount)} </small></span>);
  }
  if (row.currency_key === 'EURO') {
    return (<span className="text-secondary"><small> {'\u20AC'} {formatMoney(row.paid_amount)} </small></span>);
  }
  return '';
}

export function totalFormatter(cell, row) {
  if (row.currency_key === 'USD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.total_amount)} </small></span>);
  }
  if (row.currency_key === 'CAD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.total_amount)} </small></span>);
  }
  if (row.currency_key === 'EURO') {
    return (<span className="text-secondary"><small> {'\u20AC'} {formatMoney(row.total_amount)} </small></span>);
  }
  return '';
}

export function openFormatter(cell, row) {
  if (row.currency_key === 'USD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.open_amount)} </small></span>);
  }
  if (row.currency_key === 'CAD') {
    return (<span className="text-secondary"><small> {'\u0024'} {formatMoney(row.open_amount)} </small></span>);
  }
  if (row.currency_key === 'EURO') {
    return (<span className="text-secondary"><small> {'\u20AC'} {formatMoney(row.open_amount)} </small></span>);
  }
  return '';
}

export function amountFormatter(cell, row) {
  if(cell === ""){
    return "";
  }
  let amountToProcess = 0;
  if (cell) {
    amountToProcess = formatMoney(cell);
  }
  if (row.currency_key === 'USD') {
    return `&dollar; ${amountToProcess}`;
  }
  if (row.currency_key === 'CAD') {
    return `&dollar; ${amountToProcess}`;
  }

  return `${row.currency_key} ${amountToProcess}`;
}

export function getCurrency(row) {
  if (row === 'USD' || row.currency_key === 'USD') {
    return '$';
  }
  if (row === 'CAD' || row.currency_key === 'CAD') {
    return '$';
  }
  if (row === 'EURO' || row.currency_key === 'EURO') {
    return 'ē';
  }
  return '';
}

export function pdfFormatter(cell, row) {
  return <PdfCell row={row}/>;
}

export function mapInvoiceDetail(controlType, controlId, value, detail, isPartialPaymentsAllowed, isInvoiceOverpaymentAllowed) {
  const newDetail = detail;
  newDetail.document_number_finance = controlId;

  switch (controlType) {
    case 'payAmount':
      newDetail.amount_to_process = value;
      break;
    case 'reasonValue':
      newDetail.reason_code = value;
      break;
    case 'reasonDescription':
      newDetail.comment = value;
      break;
    default:
      newDetail.payAmount = detail.payAmount;
  }
  return newDetail;
}

export function dateFormatter(cell) {
  const locale = window.navigator.userLanguage || window.navigator.language;
  const datearray = cell.split('-');
  const newDate = new Date(datearray[2], datearray[0] - 1, datearray[1]);

  // Set locale to moment
  moment.locale(locale);

  const format = 'MM/DD/YYYY';

  const localeDate = moment(newDate, format);
  return (<span className="text-secondary"><small>{localeDate.format(format)}</small></span>);
}

export function fontStyleFormatter(cell) {
  return (<span className="text-secondary"><small>{cell}</small></span>);
}

export function statusFormatter(cell, row) {
  if (isCredit(row)) {
    return (<span className="text-secondary"><small>Credit</small></span>);
  }
  const payStatus = row.open_amount ? 'Open' : 'Cleared';
  return (<span className="text-secondary"><small>{payStatus}</small></span>);
}

export function documentNumberFormatter(cell, row) {
  let docNumber = '';
  if (row.billing_document_number) {
    docNumber = removePreceedingZero(row.billing_document_number);
    let payerNumber = removePreceedingZero(row.payer_number);
    let path = `${'/invoices/detail/'}${docNumber}/${payerNumber}`;
    return (<Link id={docNumber} href={path} to={path} onClick={this.onContinueClick}><span className="detail-link"><small>{docNumber}</small></span></Link>);
  }
  if (!row.billing_document_number && row.document_number_finance) {
    docNumber = row.document_number_finance;
  }
  return (<span className="text-secondary"><small>{docNumber}</small></span>);
}

export function documentNumberFormatterTextSecondary(cell, row) {
    let docNumber = '';
    if (row.billing_document_number) {
        docNumber = removePreceedingZero(row.billing_document_number);
        return (<span className="text-secondary"><small>{docNumber}</small></span>);
    }
    if (!row.billing_document_number && row.document_number_finance) {
        docNumber = row.document_number_finance;
    }
    return (<span className="text-secondary"><small>{docNumber}</small></span>);
}

export function referenceFormatter(cell) {
  if (cell) {
    if (isNaN(cell)) {
      return (<span className="text-secondary"><small>{cell}</small></span>);
    } else {
      return (<span className="text-secondary"><small>{removePreceedingZero(cell)}</small></span>);
    }
  }
  return '';
}

export function paymentStatusTypeFormatter(cell) {
  if (cell === 'S') {
    return (<span className="status-green">{'Success'}</span>);
  }
  return (<span className={"status-red"}>{'Error'}</span>);
}

export function invoiceTotalFormatter(total) {
  if (total > 0) {
    return (<span className="status-green">{total}</span>);
  }
  return (<span className="status-red">{total}</span>);
}

export function dueFormatter(cell, row) {
  if (isCredit(row)) {
    return '';
  }
  const locale = window.navigator.userLanguage || window.navigator.language;
  const datearray = cell.split('-');
  const newDate = new Date(datearray[2], datearray[0] - 1, datearray[1]);

  // Set locale to moment
  moment.locale(locale);
  // Get locale dataaaaaaa
  const format = 'MM/DD/YYYY';
  const localeDate = moment(newDate, format);

  // Create date from input value
  const inputDate = new Date(localeDate.format(format));

  // Get today's date
  const todaysDate = new Date();

  if (inputDate >= todaysDate) {
    return (<span className="text-secondary status-green"><small>{localeDate.format(format)}</small></span>);
  }
  return (<span className="text-secondary status-red"><small>{localeDate.format(format)}</small></span>);
}

export function daysToPayFormatter(cell, row) {
  if (typeof row.open_amount === "undefined" || isCredit(row)) {
    return '';
  }

  const dt2 = new Date(row.due_date);
  const dt1 = new Date();
  const diffDays = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
  if (diffDays > 0) {
    return (<span className="text-secondary status-green"><small>{Math.abs(diffDays)}</small></span>);
  }
  return (<span className="text-secondary status-red"><small>{Math.abs(diffDays)}</small></span>);
}

// Detail Page methods

export function calculateUnitPrice(cell, row) {
  if (row.total_amount && row.billed_quantity) {
    const unitPrice = (row.total_amount / row.billed_quantity).toFixed(2);
    const currencySymbol = getCurrency(row);
    return (<span className="text-secondary"><small>{currencySymbol}{formatMoney(unitPrice)}</small></span>);
  }
  return (<span className="text-secondary"><small/></span>);
}

export function formatTotal(cell, row) {
  if (row.total_amount) {
    const currencySymbol = getCurrency(row)
    return (<span className="text-secondary"><small>{currencySymbol}{formatMoney(row.total_amount)}</small></span>);
  }
  return (<span className="text-secondary"><small/></span>);
}

export function formatColumn(cell) {
  if (cell) {
    return (<span className="text-secondary"><small>{cell}</small></span>);
  }
  return ('');
}

export function formatDaysInArrears(cell, row) {
  if (isCredit(row)) {
    return '';
  }
  if(!(row.open_amount > 0)){
    return '';
  }
  if (cell) {
    return (<span className="text-secondary"><small>{cell}</small></span>);
  }
  return ('');
}

export function removePreceedingZero(item) {
  return parseInt(item, 10).toString();
}

export function formatMoney(amount) {
  let parsed = parseFloat(amount);
  if(Number.isNaN(parsed)){
    return "0.00";   
  }
  return Number(parseFloat(amount).toFixed(2)).toLocaleString('en', {minimumFractionDigits: 2});
}

export function soldToFormatter(cell, row) {
  if (row.zzcustom && row.zzcustom.soldtoad) {
    let address = row.zzcustom.soldtoad;
    return renderAddressForTable(address);
  } else {
    return cell;
  }
}

function renderAddressForTable(address){
  return (<div>
    <div>{address.name}</div>
    <div>{address.street}</div>
    <div>{address.city}, {address.region}, {address.country}</div>
  </div>);
}

export function payerFormatter(cell, row) {
  if (row.zzcustom && row.zzcustom.payerad) {
    let address = row.zzcustom.payerad;
    return renderAddressForTable(address);
  } else {
    return cell;
  }
}

export function reasonFormatter(cell, row) {
  if(row.reason){
    return (<span>{row.reason.description}<br/>{row.reason_message}</span>)
  } else {
    return (<span></span>)
  }
}
